import { useMutation } from "react-query";
import { useCallback, useState } from "react";
import api, { queryFetcher } from "../APIResolvers";
import { Methods } from "../pages/Settings/modules/Cost/modules/Markets/hooks/useOperateMarkets";

export interface IPylonDataProps {
  email?: string;
}

export interface IPylonResponse {
  signature: string;
  email: string;
}

export interface IUsePylonSignatureResult {
  pylonData?: IPylonResponse;
  fetchSignature: () => void;
  isLoading: boolean;
  isSuccess: boolean;
}

export const usePylonSignature = ({ email }: IPylonDataProps): IUsePylonSignatureResult => {
  const [pylonData, setPylonData] = useState<IPylonResponse>();

  const { mutate, isLoading, isSuccess } = useMutation<IPylonResponse>(
    () =>
      queryFetcher(api.pylon.ENDPOINTS.fetchPylonSignature({ email }), {
        method: Methods.POST,
        body: JSON.stringify({ email }),
      }),
    {
      onSuccess: (data) => {
        setPylonData(data);
      },
    },
  );

  const fetchSignature = useCallback(() => {
    if (email) {
      mutate();
    }
  }, [email, mutate]);

  return {
    pylonData,
    fetchSignature,
    isLoading,
    isSuccess,
  };
};
